module.exports = __webpack_public_path__ + "media/ctq-video-site-mock.mp4_ff.675dd121.mp4";